// extracted by mini-css-extract-plugin
export var bodyRow = "_ex-d";
export var cardColumns = "_ex-e";
export var ellipsesOverflow = "_ex-2";
export var flatBottomCorners = "_ex-3";
export var flatTopCorners = "_ex-4";
export var headerActionsDropdown = "_ex-f";
export var headerBottomRow = "_ex-c";
export var headerTopRow = "_ex-b";
export var orderDetailsWrapper = "_ex-0";
export var orderInfoContainer = "_ex-1";
export var productDetails = "_ex-9";
export var productImage = "_ex-5";
export var responsiveTable = "_ex-8";
export var shipmentContainer = "_ex-a";
export var tableBottomLeft = "_ex-6";
export var tableBottomRight = "_ex-7";
export var trackingLink = "_ex-g";